import React, { useEffect, useRef, useState } from "react";

const Input = ({ inputType, id, inputPlaceholder, className, required, onChange, isPhoneNumber, value, handleKeyPressInput, isZipCode,name, ref, isProfile, disabled }) => {
    const [inputValue, setInputValue] = useState(value || '');
    const inputRef = useRef(ref | null);

    useEffect(() => {
        if (value) {
            setInputValue(value);
        }
    });

   

    const handleMobileNumberChange = (event) => {
        if (isPhoneNumber) {
            let number = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
            const maxLength =  10;
            if (number.length > maxLength) {
                number = number.slice(0, maxLength); // Restrict to 10 digits
            }
            event.target.value = number; // Update the input value
        }
        if(isZipCode){
            let number = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
            const maxLength = 5;
            if (number.length > maxLength) {
                number = number.slice(0, maxLength); // Restrict to 10 digits
            }
            event.target.value = number; // Update the input value
        }
        setInputValue(event.target.value);
        onChange(event.target.value); // For non-phone number inputs
    };

    const handleCursorPosition = (event) => {
        onChange(event.target.value);
    }
    
    return (
        <input type={inputType} id={id} placeholder={inputPlaceholder}
            className={className}
            onChange={handleMobileNumberChange}
            required={required}
            value={inputValue}
            ref={inputRef}
            name={name}
            autoComplete={"off"}
            disabled={disabled}
            onClick={handleCursorPosition}
        />
    );
};

export default Input;